























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Picture from '@/components/atoms/Picture/Picture.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import ModalOptions from '@/components/Modal/ModalOptions';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Arrow2 from '@/components/icons/Arrow2.vue';
import eventBus from '@/utils/eventBus';

import { IActivationEmail } from '@/models/integrations-activation-emails';
import Tag from '@/componentsV2/atoms/Tag/Tag.vue';
import Arrow from '@/components/icons/Arrow.vue';

@Component({
  components: {
    Picture,
    GhostButton,
    Checkbox,
    FilledButton,
    Arrow,
    Arrow2,
    Tag
  }
})
export default class ActivationEmailItem extends Vue {
  @Prop() email!: IActivationEmail;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get tPrefix() {
    return 'emailAutomation';
  }

  get emailNeverActived() {
    return !this.email.enabledAt;
  }

  get invited() {
    if (this.emailNeverActived) return '-';
    return this.email.invited;
  }

  get members() {
    if (this.emailNeverActived) return '-';
    return this.email.converted;
  }

  get conversionRate() {
    if (this.emailNeverActived) return '-%';
    return `${((this.email.conversionRate || 0) * 100).toFixed(0)}%`;
  }

  clickFlow() {
    this.$router.push('/activation-emails/detail');
  }

  handleSendTestEmail() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'sendTestEmailModal',
        false,
        true,
        true,
        true,
        true
      ),
      {
        title: 'Send a test email',
        subtitle: "Email title that is very long and that's it.",
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed auctor dui id nibh pharetra convallis.'
      }
    );
  }
}
